import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from './BaseComponent';

class Answer extends BaseComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            isActive: props.isCheck
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.index !== nextProps.index || this.props.isCheck !== nextProps.isCheck) {
            this.setState({
                isActive: nextProps.isCheck
            });
        }
    }

    handleClick() {
        this.props.onAnswerClick(this.props.value, !this.state.isActive);

        this.setState({
            isActive: !this.state.isActive
        });
    }

    createRenderView(content) {
        const wrapper = Entry.createElement('div');
        if(content) {
            $('body').append(wrapper);
            wrapper.addClass(this.Styles.editorBlock);
            wrapper.addClass('blocks');
            wrapper.contentEditable = false;
            $(wrapper).attr('block', content);
            const renderView = new Entry.RenderView(wrapper, 'LEFT_MOST');
            renderView.changeCode(new Entry.Code(JSON.parse(content)), true);
            $(wrapper).detach();
        }
        return wrapper;
    }

    getAnswerView(answerText) {
        let content = '';

        if(answerText) {
            content = answerText.replace(/\*\*\*.*?\*\*\*/gim, (item)=> {
                let block = item.substring(3, item.lastIndexOf('***'));
                return $('<div>').append(this.createRenderView(block)).html();
            });
        }

        return content;
    }

    render() {
        return (
            <div
                className={`${this.Styles.answer} ${this.state.isActive ? 'active' : ''}`} onClick={this.handleClick}
            >
                <div
                    className={this.Styles.badge}
                >
                    { this.state.isActive ? '  ' : this.props.value + 1 }
                </div>
                <div
                    className={this.Styles.answerText}
                    dangerouslySetInnerHTML={{ __html: this.getAnswerView(this.props.text) }}
                />
            </div>
        );
    }
}


Answer.displayName = 'Answer';
Answer.propTypes = {
    value: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    isCorrect: PropTypes.bool.isRequired,
    onAnswerClick: PropTypes.func.isRequired,
};

export default Answer;



// WEBPACK FOOTER //
// ./components/QuizSet/Answer.js